import * as React from 'react';
import { Header, Icon, Segment, Modal, Button } from 'semantic-ui-react';
import { ActionModalContentProps } from '../interfaces/ActionModalProps';

const RescindModal = (props: ActionModalContentProps) => (
  <Modal
    basic
    size='tiny'
    closeIcon
    onClose={props.onCloseModal}
    open={props.actionModalForm.open}
  >
    <Modal.Header>
      Confirm Rescind
      &nbsp;{props.transaction.approvedAt !== null ? 'Approval' : 'Decline'}
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        Are you sure you wish rescind the transaction&nbsp;
        {props.transaction.approvedAt !== null ? 'approval' : 'decline'}?
      </Modal.Description>
      <Modal.Description>
        This will return the transaction to a pending state.
        </Modal.Description>
      {props.transactionFormTouched &&
        <Modal.Description>
          <strong>Change made to the transaction form will <i>not</i> be saved.</strong>
        </Modal.Description>
      }
    </Modal.Content>
    <Modal.Actions>
      <Button
        color='grey'
        labelPosition='right'
        icon='undo'
        content='Close'
        inverted
        size='tiny'
        onClick={props.onCloseModal}
      />
      <Button
        color='olive'
        labelPosition='right'
        icon='backward'
        content='Rescind'
        inverted
        size='tiny'
        onClick={props.onConfirm}
      />
    </Modal.Actions>
  </Modal>
)

export default RescindModal